import { Expose, Type } from 'class-transformer';

export class DestructionProcessConfigResponseDto {
    /**
     * Unique identifier for the destruction process configuration
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Reference to the client information record
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Reference to the warehouse detail for destruction
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @Expose()
    warehouseDetailId: string;

    /**
     * Whether destruction is approved by Q&C only
     * @example true
     */
    @Expose()
    approvedByQncOnly: boolean;

    @Expose()
    approvedByQncOnlyComments: string;

    /**
     * Whether destruction requires approval by both Q&C and client
     * @example false
     */
    @Expose()
    approvedByQncAndClient: boolean;

    @Expose()
    approvedByQncAndClientComments: string;

    /**
     * Reference to warehouse damage report procedure
     * @example 'WH-DMG-REP-001'
     */
    @Expose()
    warehouseDamageReportRef: string;

    /**
     * Details about product on hold reporting process
     * @example 'Products on hold require QCO approval for destruction'
     */
    @Expose()
    productOnHoldReportDetails: string;

    /**
     * Details about short-dated product reporting process
     * @example 'Short-dated products follow expedited destruction process'
     */
    @Expose()
    shortDatedReportDetails: string;

    /**
     * Whether certificate of destruction is required
     * @example true
     */
    @Expose()
    certificateOfDestructionReq: boolean;

    /**
     * Additional notes about destruction process configuration
     * @example 'Environmentally compliant destruction methods required'
     */
    @Expose()
    notes: string;

    /**
     * Timestamp when the record was created
     * @example '2024-01-15T10:30:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    createdAt: Date;

    /**
     * Timestamp when the record was last updated
     * @example '2024-01-15T15:45:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    updatedAt: Date;
}
